import React from 'react';
import styled from 'styled-components'
import { useSetting } from '../../shared/hooks/useApi/useSetting';
import { useCheckBeforeMove } from '../../shared/hooks/useCheckBeforeMove';
import { usePageOwnerIdentityStore } from '../../shared/store/pageOwnerIdentityStore';
import { useNavigate } from 'react-router-dom';


export interface LeftLogoUsernameProps {
  isHovered: boolean;
}

const LnbLogoUsername: React.FC<LeftLogoUsernameProps> = ({ isHovered }) => {
  const pageOwner = usePageOwnerIdentityStore(s => s.pageOwner);
  const { setting } = useSetting();
  const { getCurrentPage } = useCheckBeforeMove();
  const navigate = useNavigate();


  const handleUsernameClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!pageOwner) return;
    e.stopPropagation();
    if (getCurrentPage().page === 'billboard') return;
    navigate(`/@${pageOwner.handle}/`);
  }

  if (!setting) return null;

  return (
    <LnbLogoUsernameComp $isHovered={isHovered}>
      <Username onClick={(e) => handleUsernameClick(e)}>
        {setting.username}
      </Username>
    </LnbLogoUsernameComp>
  )
}

const LnbLogoUsernameComp = styled.section<{ $isHovered: boolean }>`
  width: ${({ $isHovered }) => $isHovered ? 'clamp(150px, 20vw, 210px)' : '0vw'};
  height: 7.5vh;
  display: flex;
  align-items: center;
  gap: 0.7vw;
  padding: 0.5vw clamp(12px, 1.2vw, 1.2vw);
  overflow: hidden;
  transition: width 0.6s ease-in-out;
  margin-bottom: 6vh;
`;

const Username = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-decoration: none;
  text-overflow: ellipsis;
  &:hover {
    text-decoration: ${({ theme }) => theme.fontWeight.decoration};
  }
  cursor: pointer;
  ${({ theme }) => theme.typography.Body_03_1};
  padding-left: 8px;
  pointer-events: auto;
`;


export default LnbLogoUsername;
